module.exports = __webpack_public_path__ + "assets/img/towline-multi.abb1f5ec.png";